import styled from 'styled-components'
import { TopBar } from '@equinor/eds-core-react'

export const StyledTopBar = styled(TopBar)`
    align-items: center;
    width: 100vw;

    @media (max-width: 1005px) {
        height: auto;
    }
`

export const IconStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row-reverse;
    color: white;
    > * {
        margin-left: 0.75rem;
        margin-right: 0;
    }
`

export const TitleStyle = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    > * {
        margin-right: 0.3rem;
    }
`
export const Logo = styled.img`
    height: 40px;
`
export const ClickableTitleStyle = styled(TitleStyle)`
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.8;
    }

    &:active {
        transform: scale(0.98);
    }
`
